import { motion } from "framer-motion";

export const Loader = ({ done }) => (
  <motion.div
    data-testid="page-loader"
    initial={{ y: 0 }}
    animate={{ y: done ? "-105%" : 0 }}
    transition={{ duration: 0.9, ease: [0.76, 0, 0.24, 1] }}
    className={`fixed inset-0 z-[100] bg-ink flex items-center justify-center ${
      done ? "pointer-events-none" : ""
    }`}
  >
    <div className="text-center overflow-hidden">
      <motion.div
        initial={{ y: "110%" }}
        animate={{ y: 0 }}
        transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1], delay: 0.2 }}
      >
        <span className="font-serif text-5xl md:text-7xl text-cream tracking-tight">
          OKOME
        </span>
      </motion.div>
      <motion.div
        initial={{ scaleX: 0 }}
        animate={{ scaleX: 1 }}
        transition={{ duration: 1.1, ease: [0.16, 1, 0.3, 1], delay: 0.4 }}
        className="mt-4 h-px bg-gold origin-left"
      />
      <motion.span
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.7, duration: 0.6 }}
        className="mt-4 block label-caps text-sage"
      >
        Handmade Japanese Catering
      </motion.span>
    </div>
  </motion.div>
);
